import { BaseService, NOME_TOKEN_ACESSO_DIRETO } from '@thema/base-servicos'
import moment from 'moment'

const urlConsultaEmpenhoCredor = '/service/contabilidade/empenhoCredorPortal/'

class ConsultaEmpenhoCredorService extends BaseService {
    constructor() {
        const config = JSON.parse(sessionStorage.getItem('config'))
        super(NOME_TOKEN_ACESSO_DIRETO, config)
        const adms = config.adms && config.adms.length > 0 ? config.adms.join() : null
        this.state = {
            adms: adms,
        }
    }

    consultar(filtro) {
        let data = {
            administracao: filtro.administracao.length > 0 ? filtro.administracao.map(e => e.value).join() : this.state.adms,
            exercicioEmpenhoInicial: filtro.exercicioEmpenhoInicial ? filtro.exercicioEmpenhoInicial : null,
            exercicioEmpenhoFinal: filtro.exercicioEmpenhoFinal ? filtro.exercicioEmpenhoFinal : null,
            numeroEmpenhoInicial: filtro.numeroEmpenhoInicial ? filtro.numeroEmpenhoInicial : null,
            numeroEmpenhoFinal: filtro.numeroEmpenhoFinal ? filtro.numeroEmpenhoFinal : null,
            dataEmpenhoInicial: filtro.dataEmpenhoInicial ? moment(filtro.dataEmpenhoInicial).format() : null,
            dataEmpenhoFinal: filtro.dataEmpenhoFinal ? moment(filtro.dataEmpenhoFinal).format() : null,
            dataVencimentoInicial: filtro.dataVencimentoInicial ? moment(filtro.dataVencimentoInicial).format() : null,
            dataVencimentoFinal: filtro.dataVencimentoFinal ? moment(filtro.dataVencimentoFinal).format() : null,
            pagos: filtro.pagos ? filtro.pagos.value : null,
            recurso: filtro.recurso.length > 0 ? filtro.recurso.map(e => e.value).join() : null,
            destinacao: filtro.destinacao.length > 0 ? filtro.destinacao.map(e => e.value).join() : null,
            nomeCredor: filtro.nomeCredor ? filtro.nomeCredor : null,
            cnpj: filtro.cnpj ? filtro.cnpj.replace(/\D/g, '') : null,
            cpf: filtro.cpf ? filtro.cpf.replace(/^(\d{3}).(\d{3}).(\d{3})-(\d{2})/, '$1$2$3$4') : null,
            documento: filtro.documento ? filtro.documento : null,
            exercicioProtocoloInicial: filtro.exercicioProtocoloInicial ? filtro.exercicioProtocoloInicial : null,
            exercicioProtocoloFinal: filtro.exercicioProtocoloFinal ? filtro.exercicioProtocoloFinal : null,
            numeroProtocoloInicial: filtro.numeroProtocoloInicial ? filtro.numeroProtocoloInicial : null,
            numeroProtocoloFinal: filtro.numeroProtocoloFinal ? filtro.numeroProtocoloFinal : null,
            processoReferencia: filtro.processoReferencia ? filtro.processoReferencia : null,
            categoriaProcesso: filtro.categoriaProcesso ? filtro.categoriaProcesso.value : null,
        }
        return this.conex.post(urlConsultaEmpenhoCredor + 'consultaEmpenhoCredor/', JSON.stringify(data))
    }

    consultarAquisicoesDiretas(filtro) {
        let data = {
            administracao: filtro.administracao.length > 0 ? filtro.administracao.map(e => e.value).join() : this.state.adms,
            exercicioEmpenhoInicial: filtro.exercicioEmpenhoInicial ? filtro.exercicioEmpenhoInicial : null,
            exercicioEmpenhoFinal: filtro.exercicioEmpenhoFinal ? filtro.exercicioEmpenhoFinal : null,
            numeroEmpenhoInicial: filtro.numeroEmpenhoInicial ? filtro.numeroEmpenhoInicial : null,
            numeroEmpenhoFinal: filtro.numeroEmpenhoFinal ? filtro.numeroEmpenhoFinal : null,
            dataEmpenhoInicial: filtro.dataEmpenhoInicial ? moment(filtro.dataEmpenhoInicial).utc().format() : null,
            dataEmpenhoFinal: filtro.dataEmpenhoFinal ? moment(filtro.dataEmpenhoFinal).utc().format() : null,
            dataVencimentoInicial: filtro.dataVencimentoInicial ? moment(filtro.dataVencimentoInicial).utc().format() : null,
            dataVencimentoFinal: filtro.dataVencimentoFinal ? moment(filtro.dataVencimentoFinal).utc().format() : null,
            pagos: filtro.pagos ? filtro.pagos.value : null,
            recurso: filtro.recurso.length > 0 ? filtro.recurso.map(e => e.value).join() : null,
            destinacao: filtro.destinacao.length > 0 ? filtro.destinacao.map(e => e.value).join() : null,
            nomeCredor: filtro.nomeCredor ? filtro.nomeCredor : null,
            cnpj: filtro.cnpj ? filtro.cnpj.replace(/\D/g, '') : null,
            cpf: filtro.cpf ? filtro.cpf.replace(/^(\d{3}).(\d{3}).(\d{3})-(\d{2})/, '$1$2$3$4') : null,
            documento: filtro.documento ? filtro.documento : null,
            exercicioProtocoloInicial: filtro.exercicioProtocoloInicial ? filtro.exercicioProtocoloInicial : null,
            exercicioProtocoloFinal: filtro.exercicioProtocoloFinal ? filtro.exercicioProtocoloFinal : null,
            numeroProtocoloInicial: filtro.numeroProtocoloInicial ? filtro.numeroProtocoloInicial : null,
            numeroProtocoloFinal: filtro.numeroProtocoloFinal ? filtro.numeroProtocoloFinal : null,
            processoReferencia: filtro.processoReferencia ? filtro.processoReferencia : null,
            baseLegal: filtro.baseLegal.length > 0 ? filtro.baseLegal.map(e => e.value).join() : null,
            tipoCompra: filtro.tipoCompra.length > 0 ? filtro.tipoCompra.map(e => e.value).join() : null,
        }
        return this.conex.post(urlConsultaEmpenhoCredor + 'consultaEmpenhoCredorAquisicoesDiretas/', JSON.stringify(data))
    }
}

export default ConsultaEmpenhoCredorService
